<div class="am-row align-items-center" [class.active]="isActive()" [ngClass]="item.class">
    @for (child of item.children; track trackByProp($index, child)) {
        <ng-container *vnDynamicComponent="getItemComponent(child.type); attr: { item: child, mode: mode }" />
    }
</div>
